import React, {useEffect, useState} from "react"
import OtpInput from 'react-otp-input';
import "./otp-verification.scss"
import {notification, Spin, Statistic} from 'antd';
import {Controller, useForm} from "react-hook-form";
import {useLocation, useNavigate} from "react-router";
import {Form} from "react-bootstrap"
import ThemeButton from "../../../../components/common/theme-button/ThemeButton";
import {maxLength, minLength, Required} from "../../../../utils/patterns";
import {LoadingOutlined} from '@ant-design/icons';
import {RoundedCheck} from "../../../../../assets/icons/defaultIcons";
import {UserAuthService} from "../../../../services/user-auth-api.service";
import {useUser} from "../../../../providers/UserContext";

export default function OtpVerification({redirect , otpCode,email}) {
    const { Countdown } = Statistic;
    const [deadline, setdeadline] = useState(Date.now() + 5 * 60 * 1000);
    const [inputDisabled, setInputDisabled] = useState(false); // Initially, the input is enabled
    const[disabled, setDisabled]= useState(true);
    const [resend,setResend] = useState(false)
    const [resendLoader,setResendLoader] = useState(false)
    const [btnDisabled, setBtnDisabled] = useState(false)
    const [loader, setLoader] = useState(false)
    const {otpVerified, setOtpVerified, setResetVerified} = useUser()
    const { state } = useLocation();

    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors , isValid},
        control,
        clearErrors
    } = useForm({
        mode: 'onChange',
    })
    const navigate = useNavigate()

    const onSubmit = async (data) => {
        // toast.promise(
        //     functionThatReturnPromise,
        //     {
        //         pending: 'Verifying Otp',
        //         success: 'Otp Verified 👌',
        //         error: 'Promise rejected 🤯'
        //     }
        // )
        setLoader(true)
        // setTimeout(() => {
        //     navigate(redirect)
        //     setLoader(false)
        // }, 3000);
        const result = await UserAuthService.VerifyOtpApi(data.otp, email)

        if (result?.data?.data?.status) {
            notification.success({
                message: "Success",
                description: `${result?.data?.data?.message}`,
                placement: "topRight",
                icon: <RoundedCheck/>,
                duration: 2,
            });
            setOtpVerified(true)
            setResetVerified(false)
            navigate(redirect, { state: { email: email, otp:true } });
        }
        setLoader(false)


    }
    const otpTime = () =>{
        setInputDisabled(true)
        setResend(true)
        setBtnDisabled(true)
    }

    const resetOtp = async () => {
        reset()
        clearErrors('otp')
        setResendLoader(true)
        setBtnDisabled(false)

        const result = await UserAuthService.ForgetPasswordApi(email)
        if (result){

            setdeadline(Date.now() + 5 * 60 * 1000)
            setDisabled(false)
            setResendLoader(false)
            setInputDisabled(false)
            setResend(false)
            notification.success({
                message: "OTP Sent Succesfully",
                description: result?.data?.data?.message,
                placement: "topRight",
                icon: <RoundedCheck/>,
                duration: 4,
            });

        }

        // setTimeout(()=>{
        //     notification.success({
        //         message: "OTP Sent Succesfully",
        //         description: "Kindly Check Your Email!",
        //         placement: "topRight",
        //         icon: <RoundedCheck/>,
        //         duration: 4,
        //     });
        //     setdeadline(Date.now() + 5 * 5 * 1000)
        //     setDisabled(false)
        //     setResendLoader(false)
        //     setInputDisabled(false)
        //     setResend(false)
        // },2000)
    }

    useEffect(()=>{
        if (state === null) {
            navigate('/forgot-password');
        }
    })

    useEffect(()=>{
        if (otpVerified) {
            navigate('/forgot-password');
        }
    })


    return(
        <Form onSubmit={handleSubmit(onSubmit)}>
            <div className={'otp-verification'}>
                {/*<p>Please enter the OTP you received to <br/>*/}
                {/*    <span>sam.marsh@gmail.com</span>*/}
                {/*</p>*/}
                <div className={'otp-inputs'}>
                    <Controller
                        name="otp"
                        defaultValue={''}
                        control={control}
                        rules={{required: Required, maxLength: maxLength(4), minLength:minLength(4)}}
                        render={({field}) => (
                            <>
                                <OtpInput
                                    // value={otp}
                                    // onChange={setOtp}
                                    {...field}
                                    placeholder={'----'}
                                    numInputs={4}
                                    inputType={"tel"}
                                    renderSeparator={<span>-</span>}
                                    renderInput={(props) => <input disabled={inputDisabled} {...props} />}

                                />

                            </>

                        )}


                    />


                </div>
                {/*<div>*/}
                {/*    {*/}
                {/*        <div className="errors">*/}
                {/*            {errors.otp && <small className="error-message">{errors.otp.message}</small>}*/}
                {/*        </div>*/}
                {/*    }*/}
                {/*</div>*/}
                <div className={'otp-expire'}>
                    <p> <i className={'expire-text'}>Expires in: </i>
                        <span className={'counter-numbers'}> <Countdown  value={deadline} format="mm:ss" onFinish={otpTime} /></span>

                    </p>

                </div>
                { loader &&
                <div className={'verify-otp'}>
                    <span>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 62 }} spin />} />
                        </span>
                    <span className={'text'}>Verifying Code</span>
                </div>
                }

                {
                    resend &&
                    <div className={'otp-expire'}>
                        <p className={`otp-resend`} onClick={resetOtp}>
                            <span>Didn’t receive code? </span>
                            <span className={'resend-text'} aria-disabled={true}>
                                <button className={'resend-btn'} disabled={resendLoader}>
                                    {
                                        resendLoader &&
                                        <Spin indicator={<LoadingOutlined style={{ fontSize: 18, color: 'white' }} spin />} />
                                    }
                                    Resend
                                     </button>
                                 </span>
                        </p>
                    </div>
                }



                <div className={'dfields mt-4'}>
                    <ThemeButton
                        text={'Continue'}
                        className={'btn-light-lg'}
                        type={'submit'}
                        disabled={!isValid || btnDisabled}
                        loader={loader}
                    />
                </div>
            </div>
        </Form>

    )
}